import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/admin/logs").then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-logs">
      <h1 className="font-display text-3xl tracking-tight mb-10">Logs de webhook & falhas</h1>
      <div className="border border-white/10 rounded-lg overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="logs-table">
          <thead className="bg-white/5 text-zinc-400 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-5 py-3">Data</th>
              <th className="text-left px-5 py-3">Origem</th>
              <th className="text-left px-5 py-3">Status</th>
              <th className="text-left px-5 py-3">Resumo</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-white/5" data-testid={`log-row-${l.id}`}>
                <td className="px-5 py-3 text-zinc-400 whitespace-nowrap">{new Date(l.created_at).toLocaleString("pt-BR")}</td>
                <td className="px-5 py-3 text-zinc-300">{l.source}</td>
                <td className="px-5 py-3">
                  <span className={`text-xs px-2 py-1 rounded ${
                    l.status === "processed" ? "bg-emerald-500/10 text-emerald-400" :
                    l.status === "rejected" ? "bg-amber-500/10 text-amber-400" : "bg-red-500/10 text-red-400"
                  }`} data-testid="log-status">{l.status}</span>
                </td>
                <td className="px-5 py-3 text-zinc-400 text-xs font-mono break-all">{l.summary}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="px-5 py-10 text-center text-zinc-600">Nenhum log ainda.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
